export function galleryEvents() {
	const galleries = document.querySelectorAll(".flux-product-gallery");
	if (!galleries.length) return;

	galleries.forEach((gallery) => {
		const handleFirstClick = async (event) => {
			const trigger = event.target.closest(
				"[data-gallery-main], [data-gallery-thumb]"
			);
			if (!trigger) {
				return;
			}

			gallery.removeEventListener("click", handleFirstClick);
			try {
				const { initGallery } = await import("./gallery.js");
				const handleGalleryClick = initGallery(gallery);
				handleGalleryClick(event);
			} catch (err) {
				console.error("Failed to load module:", err);
			}
		};

		gallery.addEventListener("click", handleFirstClick);
	});
}
